var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1127,
    height: 1127,
    viewBox: "0 0 1127 1127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.499 1055.51L716.989 761.293H842.228L563.501 0L284.772 761.293H410.013L563.499 1055.51ZM606.885 551.399H677.558V617.53H606.885V551.399ZM460.359 551.399H531.029V617.53H460.359V551.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.795 1127H817.366V1035.74H883.497V1127H1063.03L1027.87 940.305C1019.11 893.742 992.743 853.724 956.323 827.424H757.078L600.795 1127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.678 827.424C134.257 853.724 107.895 893.742 99.1262 940.305L63.9731 1127H243.506V1035.74H309.637V1127H526.205L369.922 827.424H170.678Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1127,
    height: 1127,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.488bfddbed3616c647b00a93d6e10d93.svg";
export { ForwardRef as ReactComponent };